import { z } from "zod";

/** Bit layout shared by the PKIL AUTOSAVE record, checkpoints.autosave_triggers and SSE (§9.3). */
export const AutosaveTrigger = { MONEY: 1, CATCH: 2, ITEM: 4, UPDATE: 8 } as const;
export type AutosaveTriggerBit = (typeof AutosaveTrigger)[keyof typeof AutosaveTrigger];

export const AutosaveTriggerName = z.enum(["money", "catch", "item", "update"]);
export type AutosaveTriggerName = z.infer<typeof AutosaveTriggerName>;

const BIT_BY_NAME: Record<AutosaveTriggerName, number> = {
  money: AutosaveTrigger.MONEY,
  catch: AutosaveTrigger.CATCH,
  item: AutosaveTrigger.ITEM,
  update: AutosaveTrigger.UPDATE,
};

export function triggersToMask(names: readonly AutosaveTriggerName[]): number {
  let m = 0;
  for (const n of names) m |= BIT_BY_NAME[n];
  return m;
}

export function maskToTriggers(mask: number): AutosaveTriggerName[] {
  return AutosaveTriggerName.options.filter((n) => (mask & BIT_BY_NAME[n]) !== 0);
}

/** Parses the server-sent AUTOSAVE_TRIGGERS config, e.g. "money,item,catch,update". */
export function parseTriggerConfig(value: string): AutosaveTriggerName[] {
  return value
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => AutosaveTriggerName.parse(s));
}

export const DEFAULT_AUTOSAVE_TRIGGERS: AutosaveTriggerName[] = ["money", "item", "catch", "update"];
